import { injectable } from 'inversify'

import { PersistentStoreBase } from '@writefull/core'

export interface SettingsStoreState {
  darkMode: boolean
}

export interface SettingsStoreActions {
  setDarkMode: (darkMode: boolean) => void
}

const initialState: SettingsStoreState = {
  darkMode: window.matchMedia('(prefers-color-scheme: dark)').matches,
}

const actions = (
  set: (fn: (state: SettingsStoreState) => SettingsStoreState) => void,
): SettingsStoreActions => ({
  setDarkMode: (darkMode: boolean) => {
    set((s) => ({ ...s, darkMode }))
  },
})

@injectable()
export class SettingsStore extends PersistentStoreBase<SettingsStoreState, SettingsStoreActions> {
  constructor() {
    super(initialState, actions, {
      version: 1,
      storageName: 'settings',
      propsToPersist: ['darkMode'],
    })
  }
}

export const settingsStore = new SettingsStore()
const useSettingsStore = settingsStore.getStore()
export default useSettingsStore
